<template>
  <b-row>
    <b-col>
      <div id="switcher-container" class="mt-3 pr-2 pl-2 pt-1 pb-1" >
        <p class="mb-1 pb-0">Stai operando per l'azienda:<b class="ml-2"><i>{{current_azi_name}}</i></b></p>
        <b-form inline v-if="show_select">
          <label for="azi-select">Modifica azienda selezionandone una tra quelle disponibili:</label>
          <b-form-select id="azi-select" size="sm" class='ml-3' v-model="selected" :options="options" @change="update_act_for"></b-form-select>
        </b-form>
      </div>
    </b-col>
  </b-row>
</template>


<script>
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'SwitcherAziende',
  data () {
    return {
      // Azienda selezionata dal referente.
      selected : null,
      //Aziende disponibili.
      options: [],
      // Flag che indica se visualizzare o meno la select di scelta
      // dell'azienda
      show_select : false
    }
  },
  computed : {
    /**
     * Torna il nome dell'azienda attualmente in uso dal referente.
     */
    current_azi_name : function () {
      return this.$store.state.session_infos.act_for.nome;
    }
  },
  methods: {
    /**
     * Alla modifica del valore nella select imposta il nuovo valore di act-for
     */
    update_act_for : function () {
      let item_selected = this.options.filter( ( item ) => { return item.value === this.selected } )[0];
      let act_for_object = { id : item_selected.value, nome : item_selected.text };
      this.$store.commit( 'set_act_for', act_for_object );
    },
    /**
     * Popola la select per la scelta dell'azienda, se l'utente è abilitato
     * solo alla sua azienda la select viene invece nascosta.
     */
    init_select : function () {
      axios.get( apiUrl.welfareapi.aziende_referente )
      .then( ( response ) => {

        // Se l'utente non ha nessuna azienda bilitata oltre la sua non possiamo
        // popolare la select, quindi la nascondiamo.
        if ( response.data.length === 0 ) {
          this.show_select = false;
          return;
        }

        // Poniamo in testa alle opzioni sempre l'azienda propria dell'utente, presa dallo store
        let user_azi_nome = this.$store.state.user.user_azi.nome + ' ' + this.$store.state.user.user_azi.cognome;
        let user_azi_id = this.$store.state.user.user_azi.id;
        this.options.push( { value : user_azi_id, text: user_azi_nome });

        // Poi aggiungiamo le altre.
        for ( let elem of response.data ) {
          this.options.push( { value: elem.id_azienda, text: elem.nome } );
        }

        // Impostiamo infine come selezionata l'azienda che è attualmente nell'act for
        this.selected = this.$store.state.session_infos.act_for.id;

      })
      .catch( ( error ) => {
        generalLib.backend_error_message_box( this, error.response.data );
      });
    }
  },
  /**
   * Alla creazione dell'elemento vediamo in quale route stiamo,
   * se siamo nella home del referente aziendale inizializziamo anche
   * la select per la scelta delle aziende su cui oeprare, altrimenti
   * la nascondiamo e verrà mostrata solo l'azienda attualmente selezionata.
   */
  created : function () {
    if ( this.$router.currentRoute.name === 'home-refazi' ) {
      this.show_select = true;
      this.init_select();
    } else {
      this.show_select = false;
    }
  }
}
</script>


<style scoped>
#switcher-container {
  border : 1px solid rgba(0,0,0,.125);
  border-radius: 5px;
}
</style>